import React, { useEffect, useState } from "react";
import api from "utils/api";
import { Bar, HorizontalBar } from "react-chartjs-2";
import APIConstant from "utils/constant";
import { Box, Tab, Tabs, Typography, IconButton, Popover } from "@material-ui/core";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Calendar } from "primereact/calendar";
import { SelectButton } from "primereact/selectbutton";
import moment from "moment";
import Spinner from "assets/Spinner.gif";

const filterOptions = ["Today", "7 Days", "30 Days"];

const Dashboard = (props) => {
  const [userId, setUserId] = useState("");
  const [tabValue, setTabValue] = useState(0);
  const [dashboardList, setDashboardList] = useState([
    {
      Name: "Stock",
      SubList: [
        {
          Name: "Inward",
          Count: 0,
        },

        {
          Name: "Outward",
          Count: 0,
        },
      ],
    },
    {
      Name: "Stock Returned",
      SubList: [
        {
          Name: "Inward",
          Count: 0,
        },
        {
          Name: "Outward",
          Count: 0,
        },
      ],
    },
    {
      Name: "Orders to be placed",
      Count: 0,
    },
    {
      Name: "Items & Goods",
      Count: 0,
    },
    {
      Name: "Total Warehouse",
      Count: 0,
      SubCount: "(Sub-Warehouse: 0)",
    },
  ]);
  const [equipmentList, setEquipmentList] = useState([
    {
      Name: "Total Repairing Costs",
      Count: 0,
    },
    {
      Name: "Total Items Used",
      Count: 0,
    },
    {
      Name: "Equipments",
      Count: 0,
    },
  ]);
  const [majorReasons, setMajorReasons] = useState(null);
  const [mostUsedItems, setMostUsedItems] = useState(null);
  const [mostUsedItemsEquipment, setMostUsedItemsEquipment] = useState(null);
  const [maintenanceCostsList, setMaintenanceCostsList] = useState([]);
  const [itemsReturnedList, setItemsReturnedList] = useState([]);
  const [itemsRefillList, setItemsRefillList] = useState([]);
  const [repairingCost, setRepairingCost] = useState(null);
  const [itemWarehouseConsumption, setItemWarehouseConsumption] = useState(null);
  const [filterDate, setFilterDate] = useState("");
  const [dateRange, setDateRange] = useState([new Date(), new Date()]);
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const [loading, setLoading] = useState(true);

  const handleFilterClick = (event) => {
    setFilterAnchorEl(event.currentTarget);
  };
  const handleFilterClose = () => {
    setFilterAnchorEl(null);
  };

  const applyQuickFilter = (value) => {
    setFilterDate(value);
    let range = null;
    const today = moment();
    switch (value) {
      case "Today":
        range = [today.startOf("day").toDate(), today.endOf("day").toDate()];
        break;
      case "7 Days":
        range = [
          moment().subtract(6, "days").startOf("day").toDate(),
          today.endOf("day").toDate(),
        ];
        break;
      case "30 Days":
        range = [
          moment().subtract(29, "days").startOf("day").toDate(),
          today.endOf("day").toDate(),
        ];
        break;
      default:
        range = null;
    }
    setDateRange(range);
  };

  const handleCalendarChange = (e) => {
    e.stopPropagation();
    setDateRange(e.value);
    setFilterDate("");
    handleFilterClose();
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: "Bar Chart",
      },
    },
    scales: {
      x: {
        beginAtZero: true,
      },
    },
  };

  useEffect(() => {
    let data = localStorage.getItem("Infodata");
    let token = localStorage.getItem("Token");

    let lockstatus = localStorage.getItem("LockStatus");

    // if (lockstatus == 0) {
    if (token !== null) {
      setUserId(data);
      // getMainDashboardAPI(data);
      // getEquipmentAPI(data);
    } else {
      props.history.push("/login");
    }
    // } else {
    //     this.props.history.push('/auth/lockscreen')
    // }
  }, []);

  useEffect(() => {
    if (userId) {
      getMainDashboardAPI(userId);
      getEquipmentAPI(userId);
    }
  }, [dateRange, userId]);

  const getMainDashboardAPI = async (UserId) => {
    let params = {
      UserId,
      DateRange: dateRange,
      FilterDate: filterDate,
    };
    let tempDashboardList = [...dashboardList];
    await api
      .post(APIConstant.path.GetTotalStocks, params)
      .then((response) => {
        if (response.Success === 1) {
          let tempData = tempDashboardList.find(
            (data) => data.Name === "Stock"
          );
          tempData.SubList[0].Count =
            response.Data.find((data) => data._id === "Inward")?.Count || 0;
          tempData.SubList[1].Count =
            response.Data.find((data) => data._id === "Outward")?.Count || 0;

          tempDashboardList[0] = tempData;
        }
      })
      .catch((err) => { });
    await api
      .post(APIConstant.path.GetReturnedStocks, params)
      .then((response) => {
        if (response.Success === 1) {
          let tempData = tempDashboardList.find(
            (data) => data.Name === "Stock Returned"
          );
          tempData.SubList[0].Count =
            response.Data.find((data) => data._id === "Inward")?.Count || 0;
          tempData.SubList[1].Count =
            response.Data.find((data) => data._id === "Outward")?.Count || 0;
          tempDashboardList[1] = tempData;
        }
      })
      .catch((err) => { });
    await api
      .post(APIConstant.path.GetOrdersToBePlaced, params)
      .then((response) => {
        if (response.Success === 1) {
          let tempData = tempDashboardList.find(
            (data) => data.Name === "Orders to be placed"
          );
          tempData.Count = response.Data.Count;
          tempDashboardList[2] = tempData;
        }
      })
      .catch((err) => { });
    await api
      .post(APIConstant.path.GetItemGoodsCount, params)
      .then((response) => {
        if (response.Success === 1) {
          let tempData = tempDashboardList.find(
            (data) => data.Name === "Items & Goods"
          );
          tempData.Count = response.Data.Count;
          tempDashboardList[3] = tempData;
        } else {
          console.error(
            "API call was not successful or data is not in the expected format:",
            response
          );
        }
      })
      .catch((err) => { });
    await api
      .post(APIConstant.path.GetTotalWarehouse, params)
      .then((response) => {
        if (response.Success === 1) {
          let tempData = tempDashboardList.find(
            (data) => data.Name === "Total Warehouse"
          );
          tempData.Count = response.Data.Count;
          tempData.SubCount = `(Sub-Warehouse: ${response.Data.SubCount})`;
          tempDashboardList[4] = tempData;
        } else {
          console.error("API response is not an object or invalid:", response);
        }
      })
      .catch((err) => { });

    setDashboardList(tempDashboardList);
    api
      .post(APIConstant.path.MostUsedItems, params)
      .then((response) => {
        const chartData = {
          labels: response.Data.map((item) => item.ItemName), // Item names as labels
          datasets: [
            {
              label: "Most Used Items",
              data: response.Data.map((item) => item.Count), // Counts as data
              backgroundColor: "rgba(54, 162, 235, 0.6)",
              borderColor: "rgba(54, 162, 235, 1)",
              borderWidth: 1,
              base: 0,
            },
          ],
        };

        setMostUsedItems(chartData);
      })
      .catch((err) => { });
    api
      .post(APIConstant.path.MajorReasons, params)
      .then((response) => {
        if (response.Success) {
          const chartData = {
            labels: response.Data.map((item) => item.Name),
            datasets: [
              {
                label: "Sell",
                data: response.Data.map((item) => item.SellCount),
                backgroundColor: "rgba(54, 162, 235, 0.6)",
                borderColor: "rgba(54, 162, 235, 1)",
                borderWidth: 1,
              },
              {
                label: "Machinery",
                data: response.Data.map((item) => item.MachineryCount),
                backgroundColor: "rgba(255, 99, 132, 0.6)",
                borderColor: "rgba(255, 99, 132, 1)",
                borderWidth: 1,
              },
              {
                label: "Warehouse",
                data: response.Data.map((item) => item.WarehouseCount),
                backgroundColor: "rgba(75, 192, 192, 0.6)",
                borderColor: "rgba(75, 192, 192, 1)",
                borderWidth: 1,
              },
            ],
          };
          setMajorReasons(chartData);
        }
      })
      .catch((err) => { });
    await api
      .post(APIConstant.path.ItemsReturned, params)
      .then((response) => {
        if (response.Success) {
          setItemsReturnedList(response.Data);
        }
      })
      .catch((err) => { });
    await api
      .post(APIConstant.path.GetRefillItems, params)
      .then((response) => {
        if (response.Success) {
          setItemsRefillList(response.Data);
        }
      })
      .catch((err) => { });
  };

  const getEquipmentAPI = async (UserId) => {
    let params = {
      UserId,
      FilterDate: filterDate,
      DateRange: dateRange,
    };
    let tempEquipmentList = [...equipmentList];
    await api
      .post(APIConstant.path.GetTotalRepairingCost, params)
      .then((response) => {
        if (response.Success === 1) {
          let tempData = tempEquipmentList.find(
            (data) => data.Name === "Total Repairing Costs"
          );
          tempData.Count = response.Count;

          tempEquipmentList[0] = tempData;
        }
      })
      .catch((err) => { });
    await api
      .post(APIConstant.path.GetTotalItemsUsed, params)
      .then((response) => {
        if (response.Success === 1) {
          let tempData = tempEquipmentList.find(
            (data) => data.Name === "Total Items Used"
          );
          tempData.Count = response.Count;
          tempEquipmentList[1] = tempData;
        }
      })
      .catch((err) => { });
    await api
      .post(APIConstant.path.GetTotalEquipments, params)
      .then((response) => {
        if (response.Success === 1) {
          let tempData = tempEquipmentList.find(
            (data) => data.Name === "Equipments"
          );
          tempData.Count = response.Count;

          tempEquipmentList[2] = tempData;
        }
      })
      .catch((err) => { });
    await api
      .post(APIConstant.path.GetRepairingCosts, params)
      .then((response) => {
        if (response.Success === 1) {
          const chartData = {
            labels: response.Data.map((item) => item.Equipment), // Item names as labels
            datasets: [
              {
                label: "Most Used Items",
                data: response.Data.map((item) => item.Price), // Counts as data
                backgroundColor: "rgba(54, 162, 235, 0.6)",
                borderColor: "rgba(54, 162, 235, 1)",
                borderWidth: 1,
                base: 0,
              },
            ],
          };

          setRepairingCost(chartData);
        }
      })
      .catch((err) => { });
    await api
      .post(APIConstant.path.GetItemsWarehouseConsumption, params)
      .then((response) => {
        if (response.Success === 1) {
          const chartData = {
            labels: response.Data.map((item) => (item.Warehouse || "")), // Item names as labels
            datasets: [
              {
                label: "Warehouse Consumption",
                data: response.Data.map((item) => item.ConsumedQuantity), // Counts as data
                backgroundColor: "rgba(54, 162, 235, 0.6)",
                borderColor: "rgba(54, 162, 235, 1)",
                borderWidth: 1,
                base: 0,
              },
            ],
          };

          setItemWarehouseConsumption(chartData);
        }
      })
      .catch((err) => { });
    await api
      .post(APIConstant.path.MostUsedItemsEquipment, params)
      .then((response) => {
        if (response.Success) {
          setMostUsedItemsEquipment(response.Data);
        }
      })
      .catch((err) => { });
    await api
      .post(APIConstant.path.GetMaintenanceCosts, params)
      .then((response) => {
        if (response.Success) {
          setMaintenanceCostsList(response.Data);
        }
      })
      .catch((err) => { });

    setEquipmentList(tempEquipmentList);
  };

  const handleTabChange = (e, value) => {
    setTabValue(value);
  };

  const actionBodyTemplateSrNo = (data, props) => {
    return props.rowIndex + 1;
  };

  return (
    <div className="p-mt-2 custom-dashboard">
      <div className="custom-tabs-container">
        <div className="dashboard-tabs p-px-4">
          <div className="dashboard-tabs-inner">
            <button
              className={`custom-tab-button ${tabValue === 0 ? "active" : ""}`}
              onClick={() => setTabValue(0)}
            >
              Main Dashboard
            </button>
            <button
              className={`custom-tab-button ${tabValue === 1 ? "active" : ""}`}
              onClick={() => setTabValue(1)}
            >
              Equipment Analytics
            </button>
          </div>
          <div className="dashboard-tab-actions">
            <IconButton size="small" className="filter-icon" onClick={handleFilterClick} aria-label="Open filters">
              <i className="pi pi-filter" style={{ fontSize: 18 }}></i>
            </IconButton>
          </div>
        </div>
        <Popover
          className="dashboard-filter-popover"
          open={Boolean(filterAnchorEl)}
          anchorEl={filterAnchorEl}
          onClose={handleFilterClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <div className="filter-popover-content">
            <div className="popover-row">
              <label className="filter-label small">⚡ Quick Selection</label>
              <SelectButton
                className="wb-filter-dt select-button-custom"
                value={filterDate}
                onChange={(e) => applyQuickFilter(e.value)}
                options={filterOptions}
              />
            </div>
            <div className="popover-row">
              <label className="filter-label small">📆 Custom Range</label>
              <Calendar
                dateFormat="dd/mm/yy"
                className="p-w-100 calendar-custom"
                placeholder="Pick start & end dates"
                value={dateRange}
                selectionMode="range"
                onChange={handleCalendarChange}
              />
            </div>
          </div>
        </Popover>
      </div>
      <div className="custom-tab-content">
        {tabValue === 0 && (
          <div className="main-card main-dashboard p-pt-0">
            <div>
              <div style={{ marginBottom: "40px" }}>
                <h2 className="section-heading section-heading-sm">
                  <i className="pi pi-chart-bar heading-icon heading-icon-sm"></i>
                  Key Business Metrics
                </h2>
                <div className="p-grid">
                  {dashboardList?.length
                    ? dashboardList?.map((item, idx) => {
                      return (
                        <div key={idx} className="p-col-12 p-md-6 p-lg-4 metric-card">
                          <div className="wb-counter-box custom-card">
                            <div className="p-d-flex p-ai-center p-mb-3 card-header">
                              <p className="metric-title">{item.Name}</p>
                            </div>
                            <div className="p-d-flex p-ai-center p-mt-3 badges-row">
                              {item.SubList ? (
                                item.SubList.map((list, index) => {
                                  return (
                                    <div key={index} className="job-d-badge">
                                      <p className="badge-label">{list.Name}</p>
                                      <p className="badge-count">{list.Count}</p>
                                    </div>
                                  );
                                })
                              ) : (
                                <div className="job-d-badge total-badge">
                                  <p className="badge-label">Total Count</p>
                                  <p className="total-count">{item.Count || 0}</p>
                                  {item.SubCount && <span className="sub-count">{item.SubCount}</span>}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })
                    : null}
                </div>
              </div>

              <div style={{ marginTop: "40px" }}>
                <h2 className="section-heading section-heading-sm">
                  <i className="pi pi-chart-line heading-icon heading-icon-sm"></i>
                  Analytics & Insights
                </h2>
              </div>
              <div className="p-grid chart-card" style={{ gap: "24px" }}>
                <div className="p-col-12 p-md-6">
                  <div className="wb-owner-chart" style={{
                    background: "linear-gradient(135deg, #fff 0%, #f8f9ff 100%)",
                    padding: "24px",
                    borderRadius: "14px",
                    boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
                    border: "1px solid #e8ecf1"
                  }}>
                    <div className="p-d-flex p-ai-center" style={{ marginBottom: "20px", borderBottom: "2px solid #e8ecf1", paddingBottom: "14px" }}>
                      <div style={{
                        background: "linear-gradient(135deg, #ff9800 0%, #f57c00 100%)",
                        width: "40px",
                        height: "40px",
                        borderRadius: "10px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginRight: "12px"
                      }}>
                        <i className="pi pi-box" style={{ fontSize: "22px", color: "#fff" }}></i>
                      </div>
                      <p style={{ margin: 0, fontWeight: 700, fontSize: "15px", color: "#2d3748" }}>Most Used Items</p>
                    </div>
                    {mostUsedItems ? (
                      <Bar data={mostUsedItems} options={options} />
                    ) : (
                      <p>No Data Found...</p>
                    )}
                  </div>
                </div>

                <div className="p-col-12 p-md-6" >
                  <div className="wb-owner-chart" style={{
                    background: "linear-gradient(135deg, #fff 0%, #f8f9ff 100%)",
                    padding: "24px",
                    borderRadius: "14px",
                    boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
                    border: "1px solid #e8ecf1"
                  }}>
                    <div className="p-d-flex p-ai-center" style={{ marginBottom: "20px", borderBottom: "2px solid #e8ecf1", paddingBottom: "14px" }}>
                      <div style={{
                        background: "linear-gradient(135deg, #dc3545 0%, #c82333 100%)",
                        width: "40px",
                        height: "40px",
                        borderRadius: "10px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginRight: "12px"
                      }}>
                        <i className="pi pi-exclamation-circle" style={{ fontSize: "22px", color: "#fff" }}></i>
                      </div>
                      <p style={{ margin: 0, fontWeight: 700, fontSize: "15px", color: "#2d3748" }}>Major Reasons</p>
                    </div>
                    {majorReasons ? (
                      <HorizontalBar
                        data={majorReasons}
                        options={{
                          ...options,
                          scales: {
                            xAxes: [
                              {
                                stacked: true,
                                ticks: {
                                  beginAtZero: true,
                                },
                              },
                            ],
                            yAxes: [
                              {
                                stacked: true,
                              },
                            ],
                          },
                        }}
                      />
                    ) : (
                      <p>No Data Found...</p>
                    )}
                  </div>
                </div>
              </div>
              <div style={{ marginTop: "40px" }}>
                <h2 className="section-heading section-heading-sm">
                  <i className="pi pi-history heading-icon heading-icon-sm"></i>
                  Transaction History
                </h2>
              </div>
              <div className="custom-large-wb-table wb-owner-chart p-my-2">
                <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "16px" }}>
                  <div style={{
                    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                    width: "36px",
                    height: "36px",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}>
                    <i className="pi pi-arrow-left" style={{ fontSize: "18px", color: "#fff" }}></i>
                  </div>
                  <p style={{ margin: 0, fontWeight: 700, fontSize: "15px", color: "#2d3748" }}>Items Returned</p>
                </div>
                <hr className="p-my-2" />
                <DataTable
                  className="main-table table-td"
                  value={itemsReturnedList}
                  editMode="row"
                  dataKey="id"
                  responsiveLayout="scroll"
                  emptyMessage="No records found"
                  columnResizeMode="fit"
                  scrollable={true}
                >
                  <Column
                    field="Index"
                    header="Sr.No"
                    body={actionBodyTemplateSrNo}
                    style={{ width: "20% !important" }}
                  ></Column>
                  <Column
                    field="Item"
                    header="Items"
                    style={{ width: "20% !important" }}
                  ></Column>
                  <Column
                    field="Unit"
                    header="Unit"
                    style={{ width: "20% !important" }}
                  ></Column>
                  <Column
                    field="ReturnedFrom"
                    header="Returned From"
                    style={{ width: "20% !important" }}
                  ></Column>
                  <Column
                    field="ReturnedTo"
                    header="Returned To"
                    style={{ width: "20% !important" }}
                  ></Column>
                  <Column
                    field="Quantity"
                    header="Qty"
                    style={{ width: "20% !important" }}
                  ></Column>
                  <Column
                    field="CreatedOn"
                    header="DateTime"
                    style={{ width: "20% !important" }}
                  ></Column>
                  <Column
                    field="Reasons"
                    header="Reasons"
                    style={{ width: "20% !important" }}
                  ></Column>
                </DataTable>
              </div>
              <div className="custom-large-wb-table wb-owner-chart p-my-2">
                <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "16px" }}>
                  <div style={{
                    background: "linear-gradient(135deg, #28a745 0%, #20c997 100%)",
                    width: "36px",
                    height: "36px",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}>
                    <i className="pi pi-plus" style={{ fontSize: "18px", color: "#fff" }}></i>
                  </div>
                  <p style={{ margin: 0, fontWeight: 700, fontSize: "15px", color: "#2d3748" }}>Items for Refill</p>
                </div>
                <hr className="p-my-2" />
                <DataTable
                  className="main-table table-td"
                  value={itemsRefillList}
                  editMode="row"
                  dataKey="id"
                  responsiveLayout="scroll"
                  emptyMessage="No records found"
                  columnResizeMode="fit"
                  scrollable={true}
                >
                  <Column
                    field="Index"
                    header="Sr.No"
                    body={actionBodyTemplateSrNo}
                    style={{ width: "20% !important" }}
                  ></Column>
                  <Column
                    field="Item"
                    header="Item/Stock"
                    style={{ width: "20% !important" }}
                  ></Column>
                  <Column
                    field="Unit"
                    header="Unit"
                    style={{ width: "20% !important" }}
                  ></Column>
                  <Column
                    field="Godown"
                    header="Godown"
                    style={{ width: "20% !important" }}
                  ></Column>
                  <Column
                    field="IdealLimit"
                    header="Ideal Limit"
                    style={{ width: "20% !important" }}
                  ></Column>
                  <Column
                    field="LowLimit"
                    header="Low Limit"
                    style={{ width: "20% !important" }}
                  ></Column>
                  <Column
                    field="CurrentQuantity"
                    header="Current Qty"
                    style={{ width: "20% !important" }}
                  ></Column>
                  <Column
                    field="OrderQuantity"
                    header="Order Qty"
                    style={{ width: "20% !important" }}
                  ></Column>
                </DataTable>
              </div>
            </div>
          </div>
        )}
        {tabValue === 1 && (
          <div className="main-card main-dashboard p-pt-0">
            <div style={{ marginBottom: "40px" }}>
              <h2 className="section-heading section-heading-sm">
                <i className="pi pi-wrench heading-icon heading-icon-sm"></i>
                Equipment Metrics
              </h2>
              <div className="p-grid">
                {equipmentList?.length
                  ? equipmentList?.map((item, idx) => {
                    return (
                      <div key={idx} className="p-col-12 p-md-6 p-lg-4 metric-card" >
                        <div className="wb-counter-box" style={{
                          background: "linear-gradient(135deg, #fff 0%, #f8f9ff 100%)",
                          padding: "24px",
                          borderRadius: "14px",
                          boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
                          border: "1px solid #e8ecf1"
                        }}>
                          <div className="p-d-flex p-ai-center p-mb-3" style={{ borderBottom: "2px solid #e8ecf1", paddingBottom: "14px" }}>
                            <p style={{ margin: 0, fontWeight: 700, fontSize: "15px", color: "#2d3748" }}>{item.Name}</p>
                          </div>
                          <div className="job-d-badge" style={{
                            background: "linear-gradient(135deg, #667eea15 0%, #764ba215 100%)",
                            border: "1.5px solid #667eea",
                            borderRadius: "10px",
                            padding: "16px",
                            textAlign: "center"
                          }}>
                            <p style={{ margin: 0, fontSize: "12px", color: "#666", marginBottom: "8px" }}>Total Count</p>
                            <p style={{ margin: 0, fontSize: "32px", fontWeight: 700, color: "#667eea" }}>{item.Count || 0}</p>
                          </div>
                        </div>
                      </div>
                    );
                  })
                  : null}
              </div>
            </div>

            <div style={{ marginTop: "40px" }}>
              <h2 className="section-heading section-heading-sm">
                <i className="pi pi-chart-line heading-icon heading-icon-sm"></i>
                Cost & Consumption Analytics
              </h2>
            </div>
            <div className="p-grid chart-card" style={{ gap: "24px" }}>
              <div className="p-col-12 p-md-6">
                <div className="wb-owner-chart" style={{
                  background: "linear-gradient(135deg, #fff 0%, #f8f9ff 100%)",
                  padding: "24px",
                  borderRadius: "14px",
                  boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
                  border: "1px solid #e8ecf1"
                }}>
                  <div className="p-d-flex p-ai-center" style={{ marginBottom: "20px", borderBottom: "2px solid #e8ecf1", paddingBottom: "14px" }}>
                    <div style={{
                      background: "linear-gradient(135deg, #dc3545 0%, #c82333 100%)",
                      width: "40px",
                      height: "40px",
                      borderRadius: "10px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginRight: "12px"
                    }}>
                      <i className="pi pi-calculator" style={{ fontSize: "22px", color: "#fff" }}></i>
                    </div>
                    <p style={{ margin: 0, fontWeight: 700, fontSize: "15px", color: "#2d3748" }}>Repairing Costs (in ₹)</p>
                  </div>
                  {repairingCost ? (
                    <Bar data={repairingCost} options={options} />
                  ) : (
                    <p>No Data Found...</p>
                  )}
                </div>
              </div>
              <div className="p-col-12 p-md-6">
                <div className="wb-owner-chart" style={{
                  background: "linear-gradient(135deg, #fff 0%, #f8f9ff 100%)",
                  padding: "24px",
                  borderRadius: "14px",
                  boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
                  border: "1px solid #e8ecf1"
                }}>
                  <div className="p-d-flex p-ai-center" style={{ marginBottom: "20px", borderBottom: "2px solid #e8ecf1", paddingBottom: "14px" }}>
                    <div style={{
                      background: "linear-gradient(135deg, #ff9800 0%, #f57c00 100%)",
                      width: "40px",
                      height: "40px",
                      borderRadius: "10px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginRight: "12px"
                    }}>
                      <i className="pi pi-warehouse" style={{ fontSize: "22px", color: "#fff" }}></i>
                    </div>
                    <p style={{ margin: 0, fontWeight: 700, fontSize: "15px", color: "#2d3748" }}>Warehouse Item Consumption</p>
                  </div>
                  {itemWarehouseConsumption ? (
                    <Bar data={itemWarehouseConsumption} options={options} />
                  ) : (
                    <p>No Data Found...</p>
                  )}
                </div>
              </div>
            </div>

            <div style={{ marginTop: "40px" }}>
              <h2 className="section-heading section-heading-sm">
                <i className="pi pi-list heading-icon heading-icon-sm"></i>
                Detailed Reports
              </h2>
            </div>
            <div className="p-grid" style={{ gap: "24px" }}>
              <div className="p-md-6">
                <div className="custom-large-wb-table wb-owner-chart p-my-2">
                  <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "16px" }}>
                    <div style={{
                      background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                      width: "36px",
                      height: "36px",
                      borderRadius: "8px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center"
                    }}>
                      <i className="pi pi-money-bill" style={{ fontSize: "18px", color: "#fff" }}></i>
                    </div>
                    <p style={{ margin: 0, fontWeight: 700, fontSize: "15px", color: "#2d3748" }}>Maintenance Costs</p>
                  </div>
                  <hr className="p-my-2" style={{ borderColor: "#e8ecf1" }} />
                  <DataTable
                    className="main-table table-td"
                    value={maintenanceCostsList}
                    editMode="row"
                    dataKey="id"
                    responsiveLayout="scroll"
                    emptyMessage="No records found"
                    columnResizeMode="fit"
                    scrollable={true}
                  >
                    <Column
                      field="Index"
                      header="Sr.No"
                      body={actionBodyTemplateSrNo}
                      style={{ width: "20% !important" }}
                    ></Column>
                    <Column
                      field="ItemName"
                      header="Items"
                      style={{ width: "20% !important" }}
                    ></Column>
                    <Column
                      field="Unit"
                      header="Unit"
                      style={{ width: "20% !important" }}
                    ></Column>
                    <Column
                      field="Expenses"
                      header="Expenses"
                      style={{ width: "20% !important" }}
                    ></Column>
                  </DataTable>
                </div>
              </div>
              <div className="p-md-6">
                <div className="custom-large-wb-table wb-owner-chart p-my-2">
                  <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "16px" }}>
                    <div style={{
                      background: "linear-gradient(135deg, #ffc107 0%, #ff9800 100%)",
                      width: "36px",
                      height: "36px",
                      borderRadius: "8px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center"
                    }}>
                      <i className="pi pi-star" style={{ fontSize: "18px", color: "#fff" }}></i>
                    </div>
                    <p style={{ margin: 0, fontWeight: 700, fontSize: "15px", color: "#2d3748" }}>Most Used Equipment Items</p>
                  </div>
                  <hr className="p-my-2" style={{ borderColor: "#e8ecf1" }} />
                  <DataTable
                    className="main-table table-td"
                    value={mostUsedItemsEquipment}
                    editMode="row"
                    dataKey="id"
                    responsiveLayout="scroll"
                    emptyMessage="No records found"
                    columnResizeMode="fit"
                    scrollable={true}
                  >
                    <Column
                      field="Index"
                      header="Sr.No"
                      body={actionBodyTemplateSrNo}
                      style={{ width: "20% !important" }}
                    ></Column>
                    <Column
                      field="ItemName"
                      header="Item Name"
                      style={{ width: "20% !important" }}
                    ></Column>
                    <Column
                      field="Unit"
                      header="Unit"
                      style={{ width: "20% !important" }}
                    ></Column>
                    <Column
                      field="IdealLimit"
                      header="IdealLimit"
                      style={{ width: "20% !important" }}
                    ></Column>
                    <Column
                      field="LowLimit"
                      header="Low Limit"
                      style={{ width: "20% !important" }}
                    ></Column>
                    <Column
                      field="CurrentQty"
                      header="Current Qty"
                      style={{ width: "20% !important" }}
                    ></Column>
                    <Column
                      field="OrderQty"
                      header="Order Qty"
                      style={{ width: "20% !important" }}
                    ></Column>
                  </DataTable>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Dashboard;
